import _get from 'lodash/get'
import { ENV } from '../constants/env'
import store from '../../_common/redux/store'

/**
 * Gets domain information from the Redux store
 * @returns {Object} Domain information
 */
const getDomainInfo = () => {
  const state = store.getState()
  return {
    isRnDomain: _get(state, 'shared.isRnDomain', false),
    isMcDomain: _get(state, 'shared.isMcDomain', false),
    MANA_CONSUMER: _get(state, 'shared.MANA_CONSUMER', ''),
  }
}

/**
 * Constructs event/tour preview URL based on consumer site or domain type
 *
 * @param {Object} options - URL construction options
 * @param {Object} options.item - Event or tour item
 * @param {string} options.type - Type of item ('event' or 'tour')
 * @param {boolean} options.isPublished - Whether the item is published
 * @param {string} options.previewKey - Preview key (if available)
 * @returns {string} Constructed URL
 */
export const constructPreviewUrl = ({ item, type = 'event', isPublished, previewKey }) => {
  // Get domain info from Redux store
  const { isRnDomain, isMcDomain, MANA_CONSUMER } = getDomainInfo()

  // Get the slug and consumerSite
  const slug = _get(item, 'slug', '')
  const attributes = _get(item, 'attributes', {})
  const consumerSite = item.consumerSite || attributes.consumerSite

  // Use consumerSite if available
  if (consumerSite) {
    const baseUrl = consumerSite.startsWith('http') ? consumerSite : `https://${consumerSite}`
    // For consumer site, only add pk parameter if needed
    if (!isPublished && previewKey) {
      return `${baseUrl}?pk=${previewKey}`
    }
    return baseUrl
  }

  // Otherwise use domain-based URL construction
  let baseUrl = ''

  // Determine the correct base URL based on domain type
  if (isRnDomain) {
    baseUrl = `${ENV.RN_CONSUMER}/events/${slug}`
  } else if (isMcDomain && MANA_CONSUMER) {
    baseUrl = `${MANA_CONSUMER}/events/${slug}`
  } else {
    // Determine the correct path segment based on type
    const pathSegment = type === 'tour' ? 'tour' : 'event'
    baseUrl = `${ENV.API_CONSUMER}/${pathSegment}/${slug}`
  }

  // Add preview key if needed and not published
  if (!isPublished && previewKey) {
    return `${baseUrl}?pk=${previewKey}`
  }

  return baseUrl
}